import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { fetchFolderListFromBrightCove, getMyProfile, getUsers } from "./actions";

export const userEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity.userId,
});

const initialState = userEntityAdapter.getInitialState({
  selectedUserId: "",
  brightCoveFolders: [],
});

export const userSlice = createSlice({
  name: "user",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getMyProfile.fulfilled, (state, action) => {
      const { status, data } = action.payload;
      if (status) {
        const { userId } = data;

        state.selectedUserId = userId;
        if (action.payload.entities?.user) {
          state.entities = {
            ...state.entities,
            ...action.payload.entities.user,
          };
        }
      }
    });
    builder.addCase(getUsers.fulfilled, (state, action) => {
      if (action.payload.success) {
        userEntityAdapter.setMany(state, action.payload.users);
      }
    });
    builder.addCase(fetchFolderListFromBrightCove.fulfilled, (state, action) => {
      if (action?.payload?.status) {
        state.brightCoveFolders = action.payload.folderData;
      }
    });
  },
});

export default userSlice.reducer;
